module.exports = __webpack_public_path__ + "img/dashboard-client.5ac397e1.svg";